<p-button icon="fas fa-upload" [label]="app.t('general.uploadFile')" (onClick)="upload()">
</p-button>
@if (value != null && value.length > 0) {
  <p-tag class="ml-3" severity="success" value="Angehängt"></p-tag>
}